import React from 'react';

const PathBlurb = () => (
  <section className="path-blurb-section">
    <div className="path-blurb-inner">
      <p className="path-blurb-text">
        {`Path is revolutionizing the uptime and performance `}
        <strong>{`monitoring industry`}</strong>
        {` by using `}
        <strong>{`XDP applications and Flow-based analytics`}</strong>
        {`. Powerful analytic tools combined with user powered monitoring nodes give unprecedented global coverage and invaluable insight into website, application, and network uptime and performance.`}
      </p>
    </div>
  </section>
);

export default PathBlurb;



// WEBPACK FOOTER //
// ./src/components/home/pathBlurb.js